<template>
  <div v-if="!isOnline" class="network-status-indicator">
    <p>You are currently offline. Please check your connection.</p>
  </div>
</template>

<script>
import { ref, onMounted, onUnmounted } from 'vue';

export default {
  name: 'NetworkStatusIndicator',
  setup() {
    const isOnline = ref(navigator.onLine);

    const updateOnlineStatus = () => {
      isOnline.value = navigator.onLine;
    };

    onMounted(() => {
      window.addEventListener('online', updateOnlineStatus);
      window.addEventListener('offline', updateOnlineStatus);
    });

    onUnmounted(() => {
      window.removeEventListener('online', updateOnlineStatus);
      window.removeEventListener('offline', updateOnlineStatus);
    });

    return {
      isOnline,
    };
  },
};
</script>

<style lang="scss" scoped>
.network-status-indicator {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  background-color: #ef4444; /* A shade of red */
  color: white;
  text-align: center;
  padding: 0.75rem;
  z-index: 1000;
  font-weight: 500;
}
</style> 